import { isDateBefore } from "../time-utils";

export type ContractStateLabel = "有効" | "終了" | "未設定";

/**
 * 契約状態の表示ラベル（#1517）。
 *
 * ストア一覧の「契約状態」列とストア概要で同じ語彙を使うための唯一の正本。
 * ホームの契約ステータスフィルタ（サーバ側 `contractStatus`: active / ended）が
 * 「有効 / 終了」なので、画面表示もそれに揃える。
 *
 * 契約終了日が未登録のストアは「契約が続いている」とも「終了した」とも言えないため
 * 「未設定」とする。旧実装は終了日 null を「契約」と断定していたため、契約日が
 * 1 件も入っていないストア（STG では 63 件中 60 件）で「契約状態: 契約 / 契約期間: 未設定」
 * という矛盾した組み合わせになっていた。
 */
export const getContractStateLabel = (contractEndDate: string | null | undefined): ContractStateLabel => {
  if (!contractEndDate) return "未設定";
  return isDateBefore(contractEndDate) ? "終了" : "有効";
};
